import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaApple, FaGooglePlay } from 'react-icons/fa';

const APP_STORE_URL = 'https://apps.apple.com/us/app/pasur-online-play-score/id6476008595';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.vakilventures.pasur';

const Bar = styled.div<{ visible: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: rgba(10, 22, 40, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--color-gold);
  padding: 0.75rem 1rem;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  transform: translateY(${({ visible }) => (visible ? '0' : '100%')});
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);

  @media (min-width: 769px) {
    display: none;
  }
`;

const StoreLink = styled.a<{ variant: 'apple' | 'google' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex: 1;
  max-width: 200px;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  text-decoration: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.3s ease;

  ${({ variant }) =>
    variant === 'apple'
      ? `
    background: white;
    color: #0a1628;
  `
      : `
    background: transparent;
    color: white;
    border: 1.5px solid rgba(255, 255, 255, 0.4);
  `}

  svg {
    font-size: 1.1rem;
  }
`;

const StickyDownloadBar: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Bar visible={visible}>
      <StoreLink
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="apple"
      >
        <FaApple /> App Store
      </StoreLink>
      <StoreLink
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="google"
      >
        <FaGooglePlay /> Google Play
      </StoreLink>
    </Bar>
  );
};

export default StickyDownloadBar;
